<template>
    <router-link :to="getRouteFromID" class="hyperLink" v-if="hasInternalLink">
        <slot></slot>
    </router-link>
    <a :href="link.linkUrl" class="hyperLink" v-else-if="hasExternalLink" target="_blank" @click="trackExternalLink(link.linkUrl)">
        <slot></slot>
    </a>
</template>
<script>
export default {
    name: "Link",
    props: ["link"],
    methods: {
        trackExternalLink(url) {
            _paq.push(["trackEvent", "external-link", window.app.vm.$route.path, url]);
        }
    },
    computed: {
        hasInternalLink() {
            return this.link.internalLink !== null
        },
        hasExternalLink() {
            return this.link.linkUrl !== ''
        },  
        getRouteFromID() {
            if(this.link.internalLink === null)
                return

            return app.manifest.getRouteFromID(this.link.internalLink);
        }
    }
};
</script>